import { BasePlugin } from '../base'
import mdcGridList from './mdc-grid-list.vue'
import mdcGridTile from './mdc-grid-tile.vue'

export { mdcGridList, mdcGridTile }

export default BasePlugin({
  mdcGridList,
  mdcGridTile
})
